// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MultipleFlavorsSelectorResult-module-container-1Y8Qf{display:block}.MultipleFlavorsSelectorResult-module-headline-UZQXg{color:#373a36;font-size:12px;font-style:normal;font-weight:var(--weight-light);margin-bottom:5px}.MultipleFlavorsSelectorResult-module-selectedItemsOverview-3Nzk2{list-style:none;display:flex;flex-wrap:wrap;gap:8px}", ""]);
// Exports
exports.locals = {
	"container": "MultipleFlavorsSelectorResult-module-container-1Y8Qf",
	"headline": "MultipleFlavorsSelectorResult-module-headline-UZQXg",
	"selectedItemsOverview": "MultipleFlavorsSelectorResult-module-selectedItemsOverview-3Nzk2"
};
module.exports = exports;
